export default __webpack_public_path__ + "static/media/twitter-white.37cf849b.svg";